import React from 'react';

// TeamMember component to display each team member's info
const TeamMember = ({ name, designation, image, description, link }) => {
  return (
    <div className="col-md-4 col-sm-4 experience-team">
      <a href={link} className="entire_mouse">
        <div className="shadow_effect effect-apollo">
          <img src={image} className="img-responsive" alt="team-image" />
        </div>
      </a>
      <h5>{name}</h5>
      <span className="designation">{designation}</span>
      <hr />
      <p className="line-height26 fnt-16">{description}</p>
    </div>
  );
};

const ExperienceTeam = () => {
  const teamMembers = [
    {
      name: "Anjali Enterprises",
      designation: "Aluminium Glass & Industrial Work Experts",
      image: "images/team-img1.jpg", // You can replace this with the actual image you want
      description: "We specialize in all types of aluminium glass office partitions, toughened glass work, door partitions, ACP cladding panel installation, soundproof glass windows, and more.",
      link: "services.html"
    },
    {
      name: "Anjali Enterprises",
      designation: "Fabrication & Installation Services",
      image: "images/team-img2.jpg", // Replace this with the image of the team member handling fabrication
      description: "Our services include MS fabrication doors, shades, grills, slide doors, industrial shades, and more. We provide the best solutions for all types of industrial and home renovation works.",
      link: "services.html"
    },
    {
      name: "Anjali Enterprises",
      designation: "Renovation & Finishing Experts",
      image: "images/team-img3.jpg", // Replace with the image of the expert in renovation and finishing
      description: "We handle all types of home renovation work, industrial fabrication, foil ceiling work, painting, mosquito net and bird net installations, and invisible grill installations.",
      link: "services.html"
    }
  ];

  return (
    <section className="experiecnce-section">
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center">
            <h3>OUR SERVICES</h3>
            <p>We provide expert services in various fields, including aluminium glass partitions, industrial fabrication, home renovation, and more.</p>
          </div>
          
          {/* Map over team members and render TeamMember component for each */}
          {teamMembers.map((member, index) => (
            <TeamMember
              key={index}
              name={member.name}
              designation={member.designation}
              image={member.image}
              description={member.description}
              link={member.link}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExperienceTeam;







